import AccessoryCart from './AccessoryCart';

import styles from './styles.module.scss';

const AccessoryRadio = () => {
  return (
    <div className={styles.accessoryRadio}>
      <AccessoryCart /> 
    </div>
  )
}

export default AccessoryRadio